import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoEmspUserListIsWebauthnEnabledCell } from './emsp-bo-emsp-user-list-is-webauthn-enabled.cell';
import { EmspBoEmspUserListIsWebauthnEnabledHeader } from './emsp-bo-emsp-user-list-is-webauthn-enabled.header';

export const EmspBoEmspUserListIsWebauthnEnabledColumn: IdentifiedColumnDef<
  EmspUserModel,
  EmspUserModel['isWebauthnEnabled']
> = {
  enableSorting: false,
  header: EmspBoEmspUserListIsWebauthnEnabledHeader,
  cell: EmspBoEmspUserListIsWebauthnEnabledCell,
};
